export default __webpack_public_path__ + "static/media/coffee.14bfb6d9.svg";